module.exports = __webpack_public_path__ + "static/media/play-button.e22e64e0.png";